import React, { useMemo } from "react";
import { useDropzone } from "react-dropzone";
import "../Programs.scss";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
  margin: "2rem 0",
  height: "120px",
  justifyContent: "center",
};

const activeStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

const Certificate = () => {
  const [certificate, setCertificate] = React.useState({
    file: "",
    fileUpload: "",
  });
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    maxFiles: 1,
    onDrop: (acceptedFiles) => {
      setCertificate((prevFiles) =>
        acceptedFiles.reduce(
          (acc, file) => ({
            ...acc,
            file: file.name,
            fileUpload: URL.createObjectURL(file),
          }),
          prevFiles
        )
      );
    },
    // accept: ".doc",
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );
  // console.log(certificate);

  const handleFileUpload = (e) => {
    console.log(e.target.files[0]);
    if (e.target.files.length) {
      setCertificate({
        ...certificate,
        fileUpload: URL.createObjectURL(e.target.files[0]),
        file: e.target.files[0].name,
      });
    }
  };
  return (
    <div>
      <h2>Upload end of program certificate</h2>
      <section className="file-certificate">
        <div {...getRootProps({ style })}>
          <input {...getInputProps()} type="file" onChange={handleFileUpload} />
          <p>Click to select files or drag files to upload</p>
        </div>
        <aside>
          <h4>Files</h4>
          <ul>{certificate.file}</ul>
        </aside>
      </section>
    </div>
  );
};

export default Certificate;
